"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _authSelectors = require("./authSelectors");
var _authActions = require("./authActions");
var _LocalAuthStore = _interopRequireDefault(require("./LocalAuthStore"));
var _helpers = require("./helpers");
var _queryString = _interopRequireDefault(require("query-string"));
var _uuid = require("uuid");
var Client = function Client(options) {
  var refreshToken = function refreshToken(_ref, callback) {
    var refreshToken = _ref.refreshToken;
    if (!refreshToken || !options.provider) {
      callback(new Error('missing refresh token or provider'), null);
    } else {
      var url = "https://" + options.domain + "/refresh";
      fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          refreshToken: refreshToken,
          provider: options.provider,
          usetokens: true
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return {
          accessToken: json.access_token,
          refreshToken: json.refresh_token,
          idToken: json.id_token,
          expiresIn: json.expires_in
        };
      }).then(function (json) {
        return callback(null, json);
      }).catch(function (err) {
        return callback(err, null);
      });
    }
  };
  var login = function login() {
    var state = (0, _uuid.v4)();
    localStorage.setItem('login-state', state);
    var query = {
      provider: options.provider,
      usetokens: true,
      state: state,
      callbackUri: options.redirectUri,
      brand: options.brand
    };
    var url = "https://" + options.domain + "/authorize?" + _queryString.default.stringify(query);
    window.location.href = url;
  };
  var callback = function callback(_callback) {
    var _queryString$parse = _queryString.default.parse(window.location.search),
      state = _queryString$parse.state,
      code = _queryString$parse.code;
    if (!code) {
      _callback(new Error('code missing'), null);
      return;
    }
    var storedState = localStorage.getItem('login-state');
    if (storedState !== state) {
      _callback(new Error('stored state mismatch'), null);
      return;
    }
    window.history.replaceState(null, '', window.location.origin + window.location.pathname);
    var url = "https://" + options.domain + "/authorize-code";
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        code: code,
        provider: options.provider,
        usetokens: true
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return {
        accessToken: json.access_token,
        refreshToken: json.refresh_token,
        idToken: json.id_token,
        expiresIn: json.expires_in
      };
    }).then(function (json) {
      return _callback(null, json);
    }).catch(function (err) {
      return _callback(err, null);
    });
  };
  return {
    refreshToken: refreshToken,
    login: login,
    callback: callback
  };
};
var AuthNobiaClient = exports.default = /*#__PURE__*/function () {
  function AuthNobiaClient(options, _temp) {
    var _this = this;
    var _ref2 = _temp === void 0 ? {} : _temp,
      store = _ref2.store,
      _ref2$preserveState = _ref2.preserveState,
      preserveState = _ref2$preserveState === void 0 ? true : _ref2$preserveState;
    this.client = void 0;
    this.localStore = void 0;
    this.store = void 0;
    this.unsubscribeFromStore = null;
    this.subscribed = false;
    this.session = null;
    this.preserveState = true;
    this.onStateChange = function () {
      var oldSession = _this.session;
      var newSession = (0, _authSelectors.sessionSelector)(_this.store.getState());
      if (oldSession !== newSession) {
        _this.setSession(newSession);
        if (_this.preserveState) {
          _this.setLocalSession(newSession);
        }
      }
    };
    this.client = Client(options);
    this.localStore = new _LocalAuthStore.default(options.clientID);
    this.store = store;
    this.session = (0, _authSelectors.sessionSelector)(store.getState());
    this.preserveState = preserveState;
  }
  var _proto = AuthNobiaClient.prototype;
  _proto.subscribe = function subscribe() {
    if (this.unsubscribeFromStore == null) {
      var session = (0, _authSelectors.sessionSelector)(this.store.getState());
      if (session != null) {
        this.setSession(session);
        if (this.preserveState) {
          this.setLocalSession(session);
        }
      }
      this.unsubscribeFromStore = this.store.subscribe(this.onStateChange);
    }
  };
  _proto.unsubscribe = function unsubscribe() {
    if (this.unsubscribeFromStore != null) {
      this.unsubscribeFromStore();
      this.unsubscribeFromStore = null;
    }
  };
  _proto.getSession = function getSession() {
    return this.session;
  };
  _proto.setSession = function setSession(session) {
    this.session = session;
  };
  _proto.getLocalSession = function getLocalSession() {
    return this.localStore.get('session');
  };
  _proto.setLocalSession = function setLocalSession(session) {
    if (session === void 0) {
      session = null;
    }
    if (session == null) {
      this.localStore.delete('session');
    } else {
      this.localStore.set('session', session);
    }
  };
  _proto.isAuthenticated = function isAuthenticated() {
    var session = this.getSession();
    return session != null && (0, _helpers.hasSessionExpired)(session) === false;
  };
  _proto.restoreLocalSession = function restoreLocalSession() {
    var localSession = this.getLocalSession();
    if (localSession != null && !(0, _helpers.hasSessionExpired)(localSession)) {
      this.store.dispatch((0, _authActions.authRequestSuccess)(localSession));
    }
  };
  _proto.handleAuthentication = function handleAuthentication(callback) {
    var _this2 = this;
    this.store.dispatch((0, _authActions.authRequest)());
    this.client.callback(function (err, result) {
      if (err) {
        _this2.store.dispatch((0, _authActions.authRequestError)(err));
      } else {
        _this2.store.dispatch((0, _authActions.authRequestSuccess)(Object.assign({}, result, {
          expiresAt: (0, _helpers.calculateExpiration)(result)
        })));
      }
      if (callback != null) {
        callback(err, result);
      }
    });
  };
  _proto.login = function login() {
    this.client.login();
  };
  _proto.logout = function logout() {
    this.localStore.clear();
    this.store.dispatch((0, _authActions.authRequestError)({}));
  };
  _proto.renewToken = function renewToken(callback) {
    var _this3 = this;
    var _sessionSelector = (0, _authSelectors.sessionSelector)(this.store.getState()),
      refreshToken = _sessionSelector.refreshToken;
    this.client.refreshToken({
      refreshToken: refreshToken
    }, function (err, result) {
      if (err) {
        _this3.store.dispatch((0, _authActions.authRequestError)(err));
      } else {
        _this3.store.dispatch((0, _authActions.authRefreshSuccess)(Object.assign({}, result, {
          expiresAt: (0, _helpers.calculateExpiration)(result)
        })));
      }
      if (callback != null) {
        callback(err, result);
      }
    });
  };
  return AuthNobiaClient;
}();